import { FederatedPointerEvent, DisplayObject } from 'pixi.js'
import Item from '../Item'
import { isIOS } from '../../helpers/features'
import { ITEM_DELAY } from '../../config/settings'
import audioManager from '../../audio/audioManager'
import { onPointerTap } from '../../helpers/events'
import { getApp } from './sceneManager'
import { centerStageOnItem } from './stagePositioning'
import gsap from 'gsap'
import { SceneState } from './types'

export function setupItemInteractions(state: SceneState): void {
  const { items } = state

  const app = getApp()
  app?.stage.on('pointerup', (e) => onStagePointerUp(e, state))
  app?.stage.on('pointerupoutside', (e) => onStagePointerUp(e, state))

  items.forEach((item) => {
    item.on('pointerover', (e) => handleItemPointerOver(e, state))
    item.on('pointerout', (e) => handleItemPointerOut(e, state))
    item.on('pointermove', () => handleItemPointerMove(state))
    onPointerTap(item, (e) => handleItemPointerUp(e, state))
  })
}

function onStagePointerUp(event: FederatedPointerEvent, state: SceneState): void {
  const { touchedItem, phase2HideTimer } = state
  const nativeEvent = (window.event ?? event.originalEvent) as PointerEvent | undefined

  // stopDragging(state)

  if (!(event.target instanceof Item)) {
    if (touchedItem) {
      // Kill any pending phase 2 timer to ensure clean state
      phase2HideTimer?.kill()
      state.phase2HideTimer = undefined

      // Ensure item returns to phase 1
      touchedItem.setHoverState(false)
      // touchedItem.itemBullet.setHoverState(false)
      state.touchedItem = undefined
    }
  }
}

// function startDragging(state: SceneState): void {
//   if (!isDesktopMode()) state.isDragging = true
// }

// function stopDragging(state: SceneState): void {
//   state.moveCounter = 0
//   if (!isDesktopMode()) state.isDragging = false
// }

function handleItemPointerMove(state: SceneState): void {
  state.moveCounter++
  // if (!state.isDragging && (state.moveCounter > 20 || isIOS)) startDragging(state)
}

function handleItemPointerUp(event: FederatedPointerEvent, state: SceneState): void {
  const { touchedItem } = state
  // if (!isDesktopMode() && state.isDragging) return stopDragging(state)
  // stopDragging(state)

  const item = event.target as Item
  if (!(item instanceof Item)) return

  // if (!isDesktopMode()) {
  //   if (touchedItem) {
  //     touchedItem.setHoverState(false)
  //     touchedItem.itemBullet.setHoverState(false)
  //   }
  //   state.touchedItem = item
  //   return
  // }

  const isTouch = event.pointerType === 'touch'

  // For tablet taps: show phase 2, stop sound, play new sound
  if (isTouch) {
    // Kill any pending hover delayed call (from pointerover)
    state.itemOverDelayedCall?.kill()

    // Cancel any previous phase 2 hide timer and ensure previous item returns to phase 1
    if (state.phase2HideTimer) {
      state.phase2HideTimer.kill()
      state.phase2HideTimer = undefined

      // Ensure previous item returns to phase 1
      if (touchedItem && touchedItem !== item) {
        touchedItem.setHoverState(false)
        // touchedItem.itemBullet.setHoverState(false)
      }
    }

    // Stop any currently playing sound immediately
    audioManager.stopItemSfx(500)

    // Show phase 2 (hover state) - but NOT the bullet for touch events
    item.setHoverState(true)
    // Don't show bullet on touch - only on mouse hover
    // item.itemBullet.setHoverState(true)
    // item.itemBullet.parent.addChild(item.itemBullet as DisplayObject)

    // Store the item so handleItemPointerOut knows not to interfere
    state.touchedItem = item

    // Play sound on touch
    audioManager.playItemSfx(item.id, null)

    // Hide phase 2 after 2 seconds - ensure it always completes
    state.phase2HideTimer = gsap.delayedCall(2, () => {
      // Double-check the item is still the touched item before resetting
      if (state.touchedItem === item) {
        item.setHoverState(false)
        // item.itemBullet.setHoverState(false)
        state.touchedItem = undefined
      }
      state.phase2HideTimer = undefined
    })
  }
}

function cycleMobileItem(direction: 1 | -1, state: SceneState): void {
  const { touchedItem, sortedItems } = state
  if (!touchedItem) return

  touchedItem.setHoverState(false)
  // touchedItem.itemBullet.setHoverState(false)

  const idx = sortedItems.indexOf(touchedItem)
  const nextIndex = (idx + direction + sortedItems.length) % sortedItems.length
  state.touchedItem = sortedItems[nextIndex]

  centerStageOnItem(state.touchedItem)
}

function handleItemPointerOver(event: FederatedPointerEvent, state: SceneState): void {
  const item = event.target as Item
  // if (!(item instanceof Item) || !isDesktopMode()) return

  // Only show bullets on mouse hover, not on touch events
  const isTouch = event.pointerType === 'touch'
  if (isTouch) return

  // const alreadyShownForItem =
  //   (activityInfoBox.isVisible?.() ?? false) && activityInfoBox.getActivity?.()?.positionId === item.id

  // Show phase 2 (hover frame) on hover
  item.setHoverState(true)
  // item.itemBullet.setHoverState(true)
  // item.itemBullet.parent.addChild(item.itemBullet as DisplayObject)

  state.itemOverDelayedCall?.kill()

  // if (!activityInfoBox.isVisible?.()) {
  state.itemOverDelayedCall = gsap.delayedCall(0, () => {
    audioManager.playItemSfx(item.id, null)
  })
  // }
}

function handleItemPointerOut(event: FederatedPointerEvent, state: SceneState): void {
  const { itemOverDelayedCall, touchedItem, phase2HideTimer } = state
  const item = event.currentTarget as Item
  // if (!(item instanceof Item) || !isDesktopMode()) return

  // Don't interfere with phase 2 animation for touch events
  if (touchedItem === item && phase2HideTimer) {
    return
  }

  itemOverDelayedCall?.kill()
  item.setHoverState(false)
  // item.itemBullet.setHoverState(false)
  audioManager.stopItemSfx(500)
}
